import { PlusIcon } from '@/utils/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const TriggerRow = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--xsmall-padding);
  width: 100%;
  padding: var(--medium-big-padding) var(--semi-big-padding);
  border: 1px solid var(--gray-border-lighter);
  border-radius: var(--xsmall-border-radius);
  background: transparent;
  color: var(--gray-muted);
  font-size: var(--small-font-size);
  font-weight: 500;
  letter-spacing: 0.28px;
  cursor: pointer;

  &:enabled:hover {
    border-color: var(--purple-dark);
  }

  &:disabled {
    color: var(--gray-darker);
    cursor: default;

    svg path {
      fill: var(--gray-darker);
    }
  }
`;

export type PhishingTranslationTriggerProps = {
  disabled: boolean;
  disabledReasonKey?: string;
  onClick: () => void;
};

export const PhishingTranslationTrigger: React.FC<
  PhishingTranslationTriggerProps
> = ({
  disabled,
  disabledReasonKey = 'phishing.translation.trigger.disabled',
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <TriggerRow type="button" disabled={disabled} onClick={onClick}>
      <PlusIcon />
      {disabled
        ? t(disabledReasonKey)
        : t('phishing.translation.trigger.label')}
    </TriggerRow>
  );
};
